// function StartTimer(){
//   const _this = this;
//   var Timer = document.querySelector(".special-timer");
//   var startTime = Timer?.getAttribute("data-startTime");

//   var countDownDate = new Date(`${startTime}`).getTime();

//   if(!isNaN(countDownDate)){
//     // Update the count down every 1 second
//     var Timer = setInterval(function() {
//       // Get today's date and time
//       var now = new Date().getTime();

//       // Find the Time between now and the count down date
//       var Time = countDownDate - now;

//       // Time calculations for days, hours, minutes and seconds
//       var days = Math.floor(Time / (1000 * 60 * 60 * 24));
//       var hours = Math.floor((Time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//       var minutes = Math.floor((Time % (1000 * 60 * 60)) / (1000 * 60));
//       minutes = minutes < 10 ? "0" + minutes : minutes;
//       var seconds = Math.floor((Time % (1000 * 60)) / 1000);
//       seconds = seconds < 10 ? "0" + seconds : seconds;

//       // Display the result in the element with id="special-timer"
//       document.querySelector(".special-timer").innerHTML ="LAUNCHES IN: "+ days + "d " + hours + "h "+ minutes + "m " + seconds + "s ";
//       //Disable the button
//       document.querySelector(".product-form__submit").style.pointerEvents = "none"; 
//       document.querySelector(".product-form__submit").setAttribute("disabled",true);

//       // If the count down is finished, write some text
//       if (Time < 0) {
//         clearInterval(Timer);
//         document.querySelector(".special-timer").innerHTML =" ";
//         document.querySelector(".product-form__submit").style.pointerEvents = "auto"; 
//         document.querySelector(".product-form__submit").style.display = "block"; 
//         document.querySelector(".with-variants-button").style.display="block";
//         document.querySelector(".product-form__submit").removeAttribute("disabled");
//         // EndTimer();
//       }

//     }, 1000);
//   }
// }
// StartTimer();



function StartTimer() {
  const timerElement = document.querySelector(".special-timer");
  const submitButtons = document.querySelectorAll(".main-product .product-form__submit");
  const variantButton = document.querySelector(".with-variants-button");

  const comingSoonCTA = document.querySelector(".coming-soon-cta");
  const comingSoonTemplate = document.querySelector(".product-page[data-coming-soon-template]");

  if (!timerElement) return;

  const startTime = timerElement.getAttribute("data-startTime");

  if (!startTime) return;

  const countDownDate = new Date(startTime).getTime();

  if (Number.isNaN(countDownDate)) {
    return;
  }

  let timerInterval;

  const stopTimer = () => {

    clearInterval(timerInterval);

    timerElement.textContent = "";

    if (comingSoonCTA) {
      comingSoonCTA.classList.add("hidden");
    }

    if (comingSoonTemplate) {
      comingSoonTemplate.removeAttribute("data-timer-running");
    }

    if (variantButton) {
      variantButton.style.display = "block";
    }

    submitButtons.forEach(btn => {
      btn.style.pointerEvents = "auto";
      btn.style.display = "flex";
      btn.removeAttribute("disabled");
    });
  };

  const updateTimer = () => {
    const timeRemaining = countDownDate - Date.now();

    // Stop as soon as the target time is reached
    if (timeRemaining <= 0) {
      stopTimer();
      return;
    }

    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));

    const hours = Math.floor(
      (timeRemaining % (1000 * 60 * 60 * 24)) /
      (1000 * 60 * 60)
    );

    const minutes = Math.floor(
      (timeRemaining % (1000 * 60 * 60)) /
      (1000 * 60)
    );

    const seconds = Math.floor(
      (timeRemaining % (1000 * 60)) /
      1000
    );

    timerElement.textContent =
      `LAUNCHES IN: ${days}d ${hours}h ${String(minutes).padStart(2, "0")}m ${String(seconds).padStart(2, "0")}s`;

    submitButtons.forEach(btn => {
      btn.style.pointerEvents = "none";
      btn.setAttribute("disabled", "true");
    });
  };

  updateTimer();

  timerInterval = setInterval(updateTimer, 1000);
}

StartTimer();